/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Affiliate_Copy_CodeInputs */

const en_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy Code`)
};

const es_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar código`)
};

const fr_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copier le code`)
};

const de_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code kopieren`)
};

const ja_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードをコピー`)
};

const zh_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制代码`)
};

const ar_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نسخ الرمز`)
};

const id_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin Kode`)
};

const it_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copia Codice`)
};

const ru_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скопировать код`)
};

const pt_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copiar Código`)
};

const ko_affiliate_copy_code = /** @type {(inputs: Affiliate_Copy_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 복사`)
};

/**
* | output |
* | --- |
* | "Copy Code" |
*
* @param {Affiliate_Copy_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const affiliate_copy_code = /** @type {((inputs?: Affiliate_Copy_CodeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Affiliate_Copy_CodeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_affiliate_copy_code(inputs)
	if (locale === "es") return es_affiliate_copy_code(inputs)
	if (locale === "fr") return fr_affiliate_copy_code(inputs)
	if (locale === "de") return de_affiliate_copy_code(inputs)
	if (locale === "ja") return ja_affiliate_copy_code(inputs)
	if (locale === "zh") return zh_affiliate_copy_code(inputs)
	if (locale === "ar") return ar_affiliate_copy_code(inputs)
	if (locale === "id") return id_affiliate_copy_code(inputs)
	if (locale === "it") return it_affiliate_copy_code(inputs)
	if (locale === "ru") return ru_affiliate_copy_code(inputs)
	if (locale === "pt") return pt_affiliate_copy_code(inputs)
	return ko_affiliate_copy_code(inputs)
});